var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.44 20.37"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vr_svg__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;stroke:#00b468}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vr_svg__\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vr_svg__\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.44 19.37H20.81l-4.59-4.59-4.59 4.59H1V1h30.44v18.37",
    stroke: "#242424",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "vr_svg__cls-2",
    d: "M8.61 13.25a3.07 3.07 0 10-3.06-3.06 3.06 3.06 0 003.06 3.06zM23.83 13.25a3.07 3.07 0 10-3.06-3.06 3.06 3.06 0 003.06 3.06z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMi40NCAyMC4zNyI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O30uY2xzLTF7c3Ryb2tlOiMyNDI0MjQ7fS5jbHMtMntzdHJva2U6IzAwYjQ2ODt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzEuNDQsMTkuMzdIMjAuODFsLTQuNTktNC41OS00LjU5LDQuNTlIMVYxSDMxLjQ0VjE5LjM3Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNOC42MSwxMy4yNWEzLjA3LDMuMDcsMCwxLDAtMy4wNi0zLjA2QTMuMDYsMy4wNiwwLDAsMCw4LjYxLDEzLjI1WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIzLjgzLDEzLjI1YTMuMDcsMy4wNywwLDEsMC0zLjA2LTMuMDZBMy4wNiwzLjA2LDAsMCwwLDIzLjgzLDEzLjI1WiIvPjwvZz48L2c+PC9zdmc+";
export { SvgVr as ReactComponent };